<!-- 保单信息 -->
<template>
  <div>
    <a-form id="container" layout="horizontal" class="horizontal_item_" :form="form">
      <a-row>
        <div id="start" class="title_">
          <div class="cutleft_">财产保全被申请人信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="财产保全被申请人">
            <a-input
              style="width: 375px"
              v-decorator="['salPolicy.policyPostName', { rules: [{ required: true, message: '请输入财产保全被申请人' }] }]"
              placeholder="请输入财产保全被申请人"
            />
          </a-form-item>
        </a-col>
        <!-- <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="被申请人证件类型">
            <a-select
              v-decorator="[
                'salPolicy.name',
                {
                  rules: [{ required: true, message: '请选择被申请人证件类型!' }],
                },
              ]"
              placeholder="请选择被申请人证件类型"
            >
              <a-select-option v-for="item in companyIdTypeOptions" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>-->
        <a-col :span="10" :offset="2">
          <a-form-item :label-col="{ span: 6 }" label="被申请人证件号">
            <a-input
              v-decorator="['salPolicy.flightnumber', { rules: [{ required: true, message: '请输入被申请人证件号！' }] }]"
              placeholder="请输入被申请人证件号"
            />
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="被申请人地址">
            <a-input
              v-decorator="['salPolicy.policyPostAddress', { rules: [{ required: true, message: '请输入被申请人地址！' }] }]"
              placeholder="请输入被申请人地址"
            />
          </a-form-item>
        </a-col>
        <a-col :span="10" :offset="2">
          <a-form-item :label-col="{ span: 6 }" label="被申请人联系电话">
            <a-input
              v-decorator="['salPolicy.policyPostTel']"
              placeholder="请输入被申请人联系电话"
            />
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="被申请人类型">
            <a-select
              v-decorator="[
                'salPolicy.isReceiveStatus',
                {
                  rules: [{ required: true, message: '请选择被申请人类型!' }],
                },
              ]"
              placeholder="请选择被申请人类型"
            >
              <a-select-option
                v-for="item in applicantType"
                :key="item.value"
                :value="item.value"
              >{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="10" :offset="2">
          <a-form-item :label-col="{ span: 6 }" label="邮编">
            <a-input
              v-decorator="['salPolicy.mailno', { rules: [{ required: true, message: '请输入邮编！' }] }]"
              placeholder="请输入邮编"
            />
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="冻结的银行名称">
            <a-input
              v-decorator="['salPolicy.bankName', { rules: [{ required: true, message: '请输入冻结的银行名称！' }] }]"
              placeholder="请输入冻结的银行名称"
            />
          </a-form-item>
        </a-col>
        <a-col :span="10" :offset="2">
          <a-form-item :label-col="{ span: 6 }" label="冻结的银行账号">
            <a-input
              v-decorator="['salPolicy.bankAccount', { rules: [{ required: true, message: '请输入冻结的银行账号！' }] }]"
              placeholder="请输入冻结的银行账号"
            />
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="冻结的财产价值">
            <a-input
              v-decorator="['salPolicy.loanNo', { rules: [{ required: true, message: '请输入冻结的财产价值！' }] }]"
              placeholder="请输入冻结的财产价值"
            />
          </a-form-item>
        </a-col>
        <a-col :span="22" v-if='planType == "zl"'>
          <a-form-item class="textarea_label" :label-col="{ span: 2 }" label="保全财产类型">
            <a-textarea
              v-decorator="[
            'salPolicy.policyresult',
            {
              rules: [{ required: true, message: '请输入保全财产类型!' }],
            },
          ]"
              placeholder="请输入保全财产类型"
              :auto-size="{ minRows: 2, maxRows: 5 }"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <div id="start" class="title_">
          <div class="cutleft_">案件信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="代理律所/律师">
            <a-input
              v-decorator="['salPolicyHolder.projectname', { rules: [{ required: true, message: '请输入被保险人代理律所/律师！' }] }]"
              placeholder="请输入被保险人代理律所/律师"
            />
          </a-form-item>
        </a-col>
        <a-col :span="10" :offset="2">
          <a-form-item :label-col="{ span: 6 }" label="联系电话">
            <a-input
              v-decorator="['salPolicyHolder.projectarea', { rules: [{ required: true, message: '请输入联系电话！' }] }]"
              placeholder="请输入联系电话"
            />
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="案件审理法院">
            <a-input
              v-decorator="['salPolicyHolder.projectaddress', { rules: [{ required: true, message: '请输入案件审理法院！' }] }]"
              placeholder="请输入案件审理法院"
            />
          </a-form-item>
        </a-col>
        <a-col :span="10" :offset="2">
          <a-form-item :label-col="{ span: 6 }" label="案号">
            <a-input
              v-decorator="['salPolicyHolder.enttypecode', { rules: [{ required: true, message: '请输入案号！' }] }]"
              placeholder="请输入案号"
            />
          </a-form-item>
        </a-col>
        <a-col :span="20">
          <a-form-item :label-col="{ span: 3 }" label="原告" style="position:relative">
            <a-input
              v-decorator="['salPolicyHolder.legalRepresentative', { rules: [{ required: true, message: '请输入原告！' }] }]"
              placeholder="请输入原告"
              style="width:375px"
            />
            <a-checkbox
              @change="onSyncname"
              style="float: right; position: absolute; right: -100px;"
            >同投保人</a-checkbox>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="被告">
            <a-input
              v-decorator="['salPolicyHolder.partyName', { rules: [{ required: true, message: '请输入被告！' }] }]"
              placeholder="请输入被告"
            />
          </a-form-item>
        </a-col>
        <a-col :span="10" :offset="2">
          <a-form-item :label-col="{ span: 6 }" label="第三人">
            <a-input v-decorator="['salPolicyHolder.thirdLimit']" placeholder="请输入第三人" />
          </a-form-item>
        </a-col>

        <a-col :span="22">
          <a-form-item class="textarea_label" :label-col="{ span: 2 }" label="案由">
            <a-textarea
              v-decorator="[
            'salPolicyHolder.additional',
            {
              rules: [{ required: true, message: '请输入案由!' }],
            },
          ]"
              placeholder="请输入案由"
              :auto-size="{ minRows: 2, maxRows: 5 }"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <div class="title_">
          <div class="cutleft_">发票信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="发票类型">
            <a-select
              v-decorator="[
                'salPolicyHolder.taxpayercertificatetype',
                { rules: [{ required: true, message: '请选择发票类型!' }]}
              ]"
              placeholder="请选择发票类型"
            >
              <a-select-option value="01">电子普票</a-select-option>
              <a-select-option value="02">专用增值税发票</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import { REQUIRERULE } from "./formRule";
let DATA = require('../data').default;
export default {
  data() {
    //这里存放数据
    return {
      form: this.$form.createForm(this, { name: 'coordinated' }),
      //被申请人证件类型
      companyIdTypeOptions: DATA.companyIdTypeOptions,
      applicantType: DATA.applicantType
    };
  },
  props:[ "planType", "name"],
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    checkFields() {
      //校验必填
      this.form.validateFields(err => {
        if (!err) {
          this.$emit('checked', true);
        } else {
          this.$emit('checked', false);
        }
      });
    },
    onSyncname() {
      this.form.setFieldsValue({
        salPolicyHolder:{
          legalRepresentative: this.name
        }
      })
    },
    save() {
      let saveData = {} 
      this.form.validateFields((err, values) => {
         saveData = values
      });
      return saveData
    }
  },
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.avatar-uploader >>> .ant-upload {
  width: 128px;
  height: 128px;
}

.textarea_label >>> .ant-col-2 {
  width: 125px !important;
}

.avatar-uploader >>> .ant-upload img {
  width: 100%;
  height: 100%;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.btn_color {
  margin: 0 20px;
}
</style>